let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("8c86m")]).then(() => parcelRequire('bnCpk'));